import type { Member } from '@/features/conversation';
import { useMemo } from 'react';

/**
 * Reusable hook for looking up a user by ID from members array
 * @param members - Array of conversation members
 * @param userId - User ID to find
 * @returns User object or undefined if not found
 */
export function useUserById(members: Member[] | undefined, userId: string | undefined) {
  return useMemo(() => {
    if (!members?.length || !userId) return undefined;
    return members.find((m) => m.userId === userId)?.user;
  }, [members, userId]);
}
